"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@mui/system");
var Cell_1 = __importDefault(require("atomicComponents/molecules/Table/Cell"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var FooterCell = (0, system_1.styled)(Cell_1.default, { shouldForwardProp: (0, general_1.omitProps)('isActionCell', 'stopPropagation') })(function (_a) {
    var theme = _a.theme, isActionCell = _a.isActionCell, stopPropagation = _a.stopPropagation;
    return (__assign({ borderBottom: "1px solid ".concat(theme.palette.grey[300]), borderTop: "1px solid ".concat(theme.palette.grey[300]), borderColor: isActionCell ? 'transparent' : undefined, height: theme.spacing(5), lineHeight: theme.spacing(4.75), whiteSpace: 'nowrap' }, (stopPropagation && { paddingLeft: theme.spacing(2.75) })));
});
exports.default = (0, DefaultPropsHoC_1.default)(FooterCell, {
    isSticky: true,
});
